import { ScreenReaderOnly } from '@capsule/consumer-design-system';

import { CAPSULE_ICON_STRINGS } from 'src/consts';

import { TransparentButton } from '../Button/TransparentButton';
import CapsuleIcon from '../CapsuleIcon';

import { CloseIconButtonContainer } from './styles';

interface CloseModalButtonProps {
  onClick: () => void;
}

export const CloseModalButton = ({ onClick }: CloseModalButtonProps) => {
  return (
    <CloseIconButtonContainer>
      <TransparentButton onClick={onClick}>
        <ScreenReaderOnly>Close Dialog</ScreenReaderOnly>
        <CapsuleIcon iconString={CAPSULE_ICON_STRINGS.close} block />
      </TransparentButton>
    </CloseIconButtonContainer>
  );
};
